<template>
  <v-card
    class="ma-3"
    v-if="AuthenticationMixin_LoggedIn && AuthenticationMixin_HasRights(['gebruiker','admin'])">
    <v-row class="justify-space-between">
      <v-col cols="9" md="6" lg="4">
        <v-text-field
          class="pa-2"
          clearable
          v-model="search"
          v-on:input="callDebounceSearch"
          append-icon="mdi-magnify"
          label="Zoeken"
        ></v-text-field>
      </v-col>
      <v-col cols="3" md="6" lg="8">
        <v-btn
          v-if="schattingSelectie.length > 0"
          class="ma-5 float-right d-none d-md-block"
          color="primary"
          @click="OpenExportDialog()"
        >
          <v-icon>mdi-export</v-icon>
          {{ exporteerSchattingTekst }}
        </v-btn>
        <v-btn
          class="ma-5 float-right d-none d-md-block"
          color="primary"
          @click="openSchatting()"
        >
          <v-icon>mdi-plus</v-icon>
          Nieuwe schatting
        </v-btn>
      <v-btn
        class="ma-5 float-right d-md-none"
        color="primary"
        @click="openSchatting()"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      </v-col>
    </v-row>

    <!-- TABLE START MET CHECKBOXES -->
    <v-data-table
      v-model="schattingSelectie"
      item-key="idSchatting"
      show-select
      dense
      :headers="headers"
      :items="items"
      :search="search"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :footer-props="{
        itemsPerPageText: 'Schattingen per pagina',
        'items-per-page-options': [25, 25, 50, 100]
      }"
      class="elevation-1"
      @click:row="openSchatting"
    >
      <template v-slot:header.data-table-select>
        <!-- Lege render om checkbox te verwijderen -->
      </template>
      <!-- <template v-slot:[`item.status`]="{ item }">
        <v-chip
        style="width: 100px;"
          small
          :color="getStatusColor(item.status)"
          dark
        >
        <span style="width: 100px; text-align: center;">{{ item.status }}</span>
        </v-chip>
      </template> -->

      <template v-slot:[`item.createTimestamp`]="{ item }">
        {{ FormatMixin_FormatDateTime(item.createTimestamp, formatMixin.date.database, formatMixin.date.date) }}
      </template>

      <template v-slot:[`item.datumPlaatsbezoek`]="{ item }">
        {{ FormatMixin_FormatDateTime(item.datumPlaatsbezoek, formatMixin.date.database, formatMixin.date.date) }}
      </template>

      <template v-slot:[`item.datumOpdracht`]="{ item }">
        {{ FormatMixin_FormatDateTime(item.datumOpdracht, formatMixin.date.database, formatMixin.date.date) }}
      </template>

      <template v-slot:[`item.datumOpmaakVerslag`]="{ item }">
        {{ FormatMixin_FormatDateTime(item.datumOpmaakVerslag, formatMixin.date.database, formatMixin.date.date) }}
      </template>

      <template v-slot:[`item.adres`]="{ item }">
        {{ item.straat }} {{ item.huisnummer }}
      </template>

      <template v-slot:[`item.acties`]="{ item }">
        <v-btn
          class="deleteItem"
          icon
          @click="deleteItem(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- EXPORT DIALOG  -->
   <v-dialog
    v-model="openExportDialog"
    :persistent="loadingExport"
    max-width="500">
     <v-card>
       <v-card-title class="text-h5">
         {{ exporteerSchattingTekst }}
       </v-card-title>
        <v-card-text>
       <v-select
          v-model="selectedFormat"
          :items="exportFormats"
          label="Exporteren als:"
          @change="onFormatChange"
        />
        <v-fade-transition>
          <v-autocomplete
            v-if="selectedFormat === 'Word (.docx)'"
            v-model="selectedTemplate"
            :items="templateOptions"
            item-text="naam"
            return-object
            label="Selecteer template:"
            class="mt-4"
            :loading="loadingTemplates"
          />
        </v-fade-transition>
        <v-text-field
          v-model="exportName"
          label="Export naam (optioneel)"
          hint="Laat leeg voor automatische naamgeving"
          persistent-hint
        />
        </v-card-text>
       <v-card-actions>
         <v-btn
           color="primary"
           text
           :disabled="loadingExport"
           @click="OpenExportDialog">
           Annuleren
         </v-btn>
         <v-spacer></v-spacer>
         <v-btn
          :disabled="selectedFormat === null || loadingExport || (selectedFormat === 'Word (.docx)' && !selectedTemplate)"
          :loading="loadingExport"
           color="primary darken-1"
           @click="VoegExportToeAanWachtrij()">
           Exporteer
         </v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>

  <!-- DELETE DIALOG -->
    <v-dialog
        v-model="deletedialog"
        max-width="500">
        <v-card>
          <v-card-title class="text-h5">
            Schatting verwijderen
          </v-card-title>
          <v-card-text v-if="selectedItem">
            Ben je zeker dat je '<strong>{{ selectedItem.straat }} {{ selectedItem.huisnummer }}, {{ selectedItem.gemeente }}</strong>' wilt verwijderen?
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary darken-1"
              @click="deletedialog = false">
              Nee
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              text
              @click="DeleteSchatting">
              Ja, verwijderen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-card>
  <v-card class="ma-3" v-else>
    <h2 class="primary--text pa-3">Log in om de schattingenlijst te kunnen bekijken.</h2>
  </v-card>

</template>

<script>
import _ from 'lodash'
import commonMixin from '../mixins/commonMixin'
import errorMixin from '../mixins/errorMixin'
import schattingService from '../services/schattingService'
import templateService from '../services/templateService'
import authenticationMixin from '../mixins/authenticationMixin'
import formatMixin from '../mixins/formatMixin'

export default {
  mixins: [
    commonMixin,
    errorMixin,
    authenticationMixin,
    formatMixin
  ],
  name: 'SchattingList',
  data () {
    return {
      selectedFormat: null,
      selectedTemplate: null,
      templateOptions: [],
      loadingTemplates: false,
      loadingExport: false,
      exportFormats: ['Word (.docx)', 'Excel (.xlsx)'],
      exportName: null,
      openExportDialog: false,
      schattingSelectie: [],
      deletedialog: false,
      action: false,
      selectedItem: null,
      totalItems: 0,
      items: [],
      search: null,
      loading: true,
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 25
      },
      headers: [
        // {
        //   text: 'Status',
        //   align: 'start',
        //   value: 'status'
        // },
        {
          text: 'Schatting aangemaakt',
          align: 'start',
          value: 'createTimestamp'
        },
        {
          text: 'Opdracht',
          align: 'start',
          value: 'opdracht'
        },
        {
          text: 'Opsteller verslag',
          align: 'start',
          value: 'gebruikerNaamOmgekeerd'
        },
        {
          text: 'Adres',
          align: 'start',
          value: 'adres'
        },
        {
          text: 'Gemeente',
          align: 'start',
          value: 'gemeente'
        },
        {
          text: 'Datum opdracht',
          align: 'start',
          value: 'datumOpdracht'
        },
        {
          text: 'Datum opmaak verslag',
          align: 'start',
          value: 'datumOpmaakVerslag'
        },
        {
          text: 'Datum plaatsbezoek',
          align: 'start',
          value: 'datumPlaatsbezoek'
        },
        {
          text: '',
          sortable: false,
          align: 'center',
          value: 'acties'
        }
      ]
    }
  },
  watch: {
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true
    },
    deletedialog () {
      if (!this.deletedialog) {
        this.action = false
      }
    }
  },
  async mounted () {
    await schattingService.Init(this)
    await templateService.Init(this)
    this.getDataFromApi()
  },
  computed: {
    exporteerSchattingTekst () {
      if (this.schattingSelectie.length > 1) {
        return `Exporteer ${this.schattingSelectie.length} schattingen`
      } else if (this.schattingSelectie.length === 1) {
        return 'Exporteer 1 schatting'
      } else {
        return `Exporteer alle (${this.totalItems}) schattingen`
      }
    }
  },
  methods: {
    async loadTemplates () {
      const response = await templateService.GetAll(true)
      if (response && response.data) {
        this.templateOptions = response.data
      }
    },
    async OpenExportDialog () {
      this.openExportDialog = !this.openExportDialog
      this.selectedFormat = null
      this.selectedTemplate = null
      this.exportName = null
    },
    async onFormatChange () {
      this.selectedTemplate = null
      if (this.selectedFormat === 'Word (.docx)') {
        this.loadingTemplates = true
        await this.loadTemplates()
        this.loadingTemplates = false
      }
    },
    async GetSchattingenPaged (sortBy, sortType, search, page, pageSize) {
      const response = await schattingService.GetSchattingenPaged(sortBy, sortType, search, page, pageSize)
      if (response && response.data) {
        const data = response.data
        this.items = data.items
        this.totalItems = data.totalItems
      }
    },
    async getDataFromApi () {
      console.log('getDataFromApi')
      this.loading = true
      await this.GetSchattingenPaged(this.options.sortBy[0], this.options.sortDesc[0] ? 'desc' : 'asc', this.search, this.options.page, this.options.itemsPerPage).then(data => {
        this.loading = false
      })
    },
    getStatusColor (status) {
      switch (status) {
        case 'Afgehandeld':
          return '#2e7a2e'
        case 'Aanpassen':
          return '#356191'
        case 'Concept':
          return 'darkgrey'
      }
    },
    callDebounceSearch: _.debounce(function () {
      this.debounceSearch()
    }, 500),
    debounceSearch () {
      this.getDataFromApi()
    },
    deleteItem (item) {
      this.selectedItem = item
      this.action = true
      this.deletedialog = true
    },
    downloadTemplate (item) {
      this.selectedItem = item
      this.action = true
      this.$router.push({ path: 'Template', query: { id: item.idSchatting } })
    },
    async VoegExportToeAanWachtrij () {
      this.loadingExport = true
      const itemsToExport = this.schattingSelectie.length > 0 ? this.schattingSelectie : this.items

      if (this.selectedFormat === 'Word (.docx)') {
        var format = 'word'
        if (!this.selectedTemplate || !this.selectedTemplate.idBlob) {
          this.CommonMixin_Snackbar('Selecteer een template', 'error')
          this.loadingExport = false
          return
        }

        try {
          const idBlob = this.selectedTemplate.idBlob
          if (idBlob) {
            try {
              const template = {
                IdBlob: idBlob,
                ItemIds: itemsToExport.map(item => item.idSchatting),
                ExportName: this.exportName
              }

              // Call AddExportToQueue
              const response = await templateService.AddExportToQueue(template, format, 'schatting')
              if (response && response.data) {
                const message = 'Export toegevoegd aan de wachtrij'
                this.CommonMixin_Snackbar(message, 'success')

                this.openExportDialog = false
                this.selectedFormat = null
              } else {
                this.ErrorMixin_HandleError({ message: 'Kon het bestand niet toevoegen aan wachtrij. Probeer het opnieuw.' })
              }
            } catch (error) {
              this.ErrorMixin_HandleError(error)
            } finally {
              this.loadingExport = false
            }
          } else {
            this.ErrorMixin_HandleError({ message: 'Template blob niet gevonden' })
            this.loadingExport = false
          }
        } catch (error) {
          this.ErrorMixin_HandleError(error)
        } finally {
          this.loadingExport = false
        }
      } else {
        // Export naar excel
        format = 'excel'
        try {
          const template = {
            ItemIds: itemsToExport.map(item => item.idSchatting),
            ExportName: this.exportName
          }
          // Call AddExportToQueue
          const response = await templateService.AddExportToQueue(template, format, 'schatting')
          if (response && response.data) {
            const message = 'Export toegevoegd aan de wachtrij'
            this.CommonMixin_Snackbar(message, 'success')

            this.openExportDialog = false
            this.selectedFormat = null
          } else {
            this.ErrorMixin_HandleError({ message: 'Kon het bestand niet toevoegen aan wachtrij. Probeer het opnieuw.' })
          }
        } catch (error) {
          this.ErrorMixin_HandleError(error)
        } finally {
          this.loadingExport = false
        }
      }
      this.schattingSelectie = []
    },
    async openSchatting (id) {
      if (!this.action) {
        if (id) {
          this.$router.push({ path: 'Schatting', query: { id: id.idSchatting } })
        } else {
          var gebruiker = this.AuthenticationMixin_GetCurrentGebruiker()
          if (gebruiker && gebruiker.idGebruiker) {
            var response = await schattingService.CreateNewSchatting({ idGebruiker: gebruiker.idGebruiker })
            if (response && response.data) {
              var idNewSchatting = response.data
              this.idSchatting = idNewSchatting
              this.$router.push({ path: 'Schatting', query: { id: idNewSchatting } })
            }
          }
        }
      }
    },
    async DeleteSchatting () {
      const response = await schattingService.DeleteSchatting(this.selectedItem.idSchatting)
      if (response && response.data) {
        this.getDataFromApi()
      }
      this.editdialog = false
      this.deletedialog = false
    }
  }
}
</script>
